var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoColorXing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 75,
    viewBox: "0 0 150 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 150,
    height: 75,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009E9F",
    d: "m18.97 27 3.978 7.273L17 45h7.091L30 34.273 26.021 27H18.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3CB65",
    d: "M39.748 20 28 40.448 35.576 54h7.373l-7.697-13.552L47 20h-7.252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.608 23.35h-4.887v27.3h5.642V35.207l9.297 15.443h4.728v-27.3h-5.642v15.442L95.608 23.35zM134 34.978h-9.586v4.712h4.278v5.93c-.99.392-1.861.55-2.891.55-4.397 0-6.22-3.26-6.22-9.071 0-5.42 1.585-9.347 6.774-9.347 1.743 0 3.644.47 5.506 1.296l1.664-4.36C131.227 23.51 128.732 23 126.117 23c-8.516 0-12.279 5.301-12.279 14.059 0 8.953 3.605 13.941 11.963 13.941 2.693 0 5.426-.55 8.199-1.846V34.978zM79.928 50.65h5.801v-27.3h-5.8v27.3zm-18.332-27.3 4.172 8.706 4.57-8.706h5.96l-7.312 13.079 7.59 14.221h-6.239l-4.688-9.533-4.65 9.533H55l7.231-14.142-6.913-13.158h6.278z",
    fill: "#009E9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoColorXing);
export default __webpack_public_path__ + "static/media/kundenlogo-color-xing.eff6dcb7863bbda17f8f0f0db2e8b7f8.svg";
export { ForwardRef as ReactComponent };